let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5W6c9")).then(() => parcelRequire('dlAc5'));